var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm.editPrefix
            ? _c("w-input", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.bookyear"),
                    expression: "$ct('tooltip.bookyear')",
                  },
                ],
                ref: "prefixInput",
                attrs: { label: _vm.$ct("id-edit-prefix"), fancy: "" },
                on: {
                  blur: function ($event) {
                    _vm.editPrefix = false
                  },
                },
                model: {
                  value: _vm.value.Prefix,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Prefix", $$v)
                  },
                  expression: "value.Prefix",
                },
              })
            : _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("div", { staticClass: "prefix-label" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("id-edit-prefix")) + " "),
                    ]),
                    _vm._v(" " + _vm._s(_vm.computedPrefix) + " "),
                  ]),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.editPrefixClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input-number", {
            attrs: {
              "calculated-decimals": 0,
              decimals: 0,
              label: _vm.$ct("id-edit-length"),
              fancy: "",
            },
            model: {
              value: _vm.value.NumberLength,
              callback: function ($$v) {
                _vm.$set(_vm.value, "NumberLength", $$v)
              },
              expression: "value.NumberLength",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input-number", {
            attrs: {
              "calculated-decimals": 0,
              decimals: 0,
              label: _vm.$ct("id-edit-start"),
              fancy: "",
            },
            model: {
              value: _vm.value.StartingNumber,
              callback: function ($$v) {
                _vm.$set(_vm.value, "StartingNumber", $$v)
              },
              expression: "value.StartingNumber",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input-number", {
            attrs: {
              "calculated-decimals": 0,
              decimals: 0,
              label: _vm.$ct("id-edit-end"),
              fancy: "",
            },
            model: {
              value: _vm.value.EndNumber,
              callback: function ($$v) {
                _vm.$set(_vm.value, "EndNumber", $$v)
              },
              expression: "value.EndNumber",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }